import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filterByProp',
    standalone: false
})

@Injectable()
export class FilterArrayByItemPropertyPipe implements PipeTransform {
    transform(array: Array<any>, propName: string, needFilter: boolean = true): Array<any> {
        if (needFilter) {
            return array.filter(item => {
                return item[propName];
            } );
        } else {
            return array;
        }
    }
}
